import styled from '@emotion/styled';
import { ContentWrapper, fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Section = styled(ContentWrapper)`
  padding: 72px 0;

  h1 {
    margin-bottom: 56px;
  }

  @media only screen and (max-width: 1350px) {
    padding: 48px 15px;
  }

  @media only screen and ${breakpoint.lg} {
    h1 {
      margin-bottom: 26px;
      font-size: ${fontSize(32)};
    }
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 31px;
  color: rgba(255, 255, 255, 0.8);

  @media only screen and ${breakpoint.xl} {
    flex-wrap: wrap;
  }
`;

export const Tile = styled.div`
  padding: 24px 32px;
  background: ${({ image }) => `url(${image}) no-repeat`};
  background-position: center top;
  background-size: 100% auto;
  width: 305px;
  height: 305px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  box-shadow: ${({ theme }) => theme.shadow.medium};
  cursor: pointer;

  h3 {
    font-size: ${fontSize(32)};
    color: rgba(255, 255, 255, 0.8);
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  @media only screen and (max-width: 1300px) {
    width: 100%;
    height: 240px;
    box-shadow: none;

    &:nth-of-type(2) {
      width: calc(100% - 50px);
      margin: auto;
    }

    &:not(:nth-of-type(2)) {
      padding: 24px 50px;
    }

    h3 {
      font-size: ${fontSize(24)};
    }
  }

  @media only screen and ${breakpoint.md} {
    width: 100%;
    max-width: unset;
  }

  @media only screen and (max-width: 600px) {
    &:not(:nth-of-type(2)) {
      padding: 24px 40px;
    }

    &:nth-of-type(2) {
      width: calc(100% - 30px);
    }
  }

  @media only screen and (max-width: 400px) {
    &:nth-of-type(2) {
      width: calc(100% - 20px);
    }
  }
`;

export const Description = styled.p`
  font-family: ${({ theme }) => theme.defaults.fontFamily.secondary};
  font-size: ${fontSize(16)};
  font-weight: 400;
  letter-spacing: -0.24px;
`;
